module.exports = __webpack_public_path__ + "static/media/silvasa4.a032e3e0.webp";